import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKayakingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M3.4.436C2.492-.419 1 .226 1 1.475v.827c0 .818.34 1.599.937 2.157a2.08 2.08 0 002.731.093l6.78 6.78a2.08 2.08 0 00.093 2.731 2.95 2.95 0 002.157.937h.827c1.249 0 1.894-1.49 1.039-2.4l-1.33-1.417c-.451-.479-1.1-.66-1.7-.533l-.39-.39c2.689-3.194 3.502-6.76 3.748-8.503A1.443 1.443 0 0014.242.11C12.5.357 8.93 1.173 5.74 3.856l-.39-.39c.127-.6-.054-1.249-.533-1.7zM2.25 1.475c0-.154.183-.233.295-.128l1.416 1.33c.227.214.24.57.028.799l-.025.026a.829.829 0 01-1.174.044 1.701 1.701 0 01-.54-1.244zm9.006 7.898l-.633-.634c.264-.41.391-.861.376-1.32-.023-.633-.315-1.21-.762-1.656-.446-.447-1.023-.74-1.656-.761a2.272 2.272 0 00-1.32.375l-.634-.633c2.92-2.418 6.18-3.168 7.791-3.397.09-.013.15.017.184.052.035.034.065.093.052.184-.227 1.61-.975 4.867-3.398 7.79zm-1.56-1.561L8.187 6.305a.957.957 0 01.35-.054c.264.009.553.133.816.396.262.262.386.551.395.816a.957.957 0 01-.054.349zm4.957 5.643a.175.175 0 01-.128.295h-.827a1.7 1.7 0 01-1.244-.54.829.829 0 01.044-1.174l.027-.025a.567.567 0 01.797.028z" />
        <path d="M.108 14.246c.249-1.764 1.08-5.404 3.855-8.631l.886.886c-2.508 2.957-3.273 6.287-3.504 7.92-.012.09.017.148.052.183.034.034.093.063.183.05 1.632-.23 4.963-.995 7.919-3.503l.886.887c-3.227 2.775-6.867 3.605-8.63 3.854a1.442 1.442 0 01-1.647-1.646z" />
        <path d="M5.357 8.236c.094-.283.208-.58.348-.88l.953.954c-.041.106-.079.213-.114.32-.101.304-.015.547.132.694.147.147.39.234.694.133.107-.036.214-.074.32-.115l.953.953c-.298.14-.596.254-.879.348-1.538.51-2.918-.868-2.407-2.407z" />
      </g>
    </svg>
  )
);
SvgSportsKayakingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKayakingNormalXsmall;
